import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Row, Col } from "react-bootstrap";
import Shorttext from "./FormElement/Shorttext";
import DropDown from "./FormElement/DropDown";
import Longtext from "./FormElement/Longtext";
import Numbers from "./FormElement/Numbers";
import Description from "./FormElement/Description";
import YesNoChoose from "./FormElement/YesNoChoose";
import Checkbox from "./FormElement/Checkbox";
import Radiobutton from "./FormElement/Radiobutton";
import FileDownload from "./FormElement/FileDownload";
import FileUpload from "./FormElement/FileUpload";
import Dates from "./FormElement/Dates";
import Times from "./FormElement/Times";
import PageBreak from "./FormElement/PageBreak";
import { convertTextToLink, formatDateLocal } from "../../../Utils";
import Emails from "./FormElement/Emails";
import Confirmations from "./FormElement/Confirmations";
import { ThankYouModal } from "../../../Components/Modal/ThankYouModal";
import AutoComplete from "./FormElement/AutoComplete";
import Paragraph from "./FormElement/Paragraph";
import VideoComp from "./FormElement/VideoComp";
import Images from "./FormElement/Images";
import Rating from "./FormElement/Rating";
import MultiInput from "./FormElement/MutiInput";
import VideoRecord from "./FormElement/VideoRecord";
import MultiCheckbox from "./FormElement/MultiCheckbox";
import Signature from "./FormElement/Signature";
import Website from "./FormElement/Website";
import PhoneNo from "./FormElement/PhoneNo";
import Address from "./FormElement/Address";

const Application = ({
  formDetails,
  formId,
  first,
  setfirst,
  handleApplicationSave = { handleApplicationSave },
  setviewForm,
  viewForm,
  setcounter,
  counter,
  retFind,
  modalShow,
  setModalShow,
  viewFormAction,
  appID,
  subFlag,
  queryParams,
  waits,
}) => {
  const { t } = useTranslation();
  const [isFormActive, setIsFormActive] = useState(true);
  const [isEndDateExpired, setIsEndExpired] = useState(false);
  const [notActiveMessage, setNotActiveMessage] = useState("");

  useEffect(() => {
    const currentDate = new Date().setHours(0, 0, 0, 0);
    if (formDetails?.enableForm) {
      if (
        formDetails?.formSetting?.startForm &&
        formDetails?.status === "Not Started"
      ) {
        const startDate = new Date(formDetails.formSetting.startForm).setHours(
          0,
          0,
          0,
          0
        );
        if (startDate > currentDate) {
          setIsFormActive(false);
          setNotActiveMessage(
            t("auth.formBuilder.formNotActive.startDate", {
              startDate: formatDateLocal(startDate),
            })
          );
          return;
        }
      }

      if (formDetails?.formSetting?.endForm) {
        const endDate = new Date(formDetails.formSetting.endForm).setHours(
          0,
          0,
          0,
          0
        );
        if (endDate < currentDate) {
          if (formDetails?.status === "Not Started") {
            setIsFormActive(false);
            setNotActiveMessage(t("auth.formBuilder.formNotActive.endDate"));
            return;
          }
          setIsEndExpired(true);
          return;
        }
      }
      setIsFormActive(true);
    } else {
      if (formDetails?.status !== "Not Started") {
        setIsFormActive(true);
        return;
      }
      setIsFormActive(false);
      setNotActiveMessage(t("auth.formBuilder.formNotActive.enableForm"));
    }

    // if (formDetails?.formSetting?.endForm) {
    //   const endDate = new Date(formDetails.formSetting.endForm);
    //   if (endDate <= currentDate) {
    //     setIsEndExpired(true)
    //     return;
    //   }
    // }
  }, [formDetails]);

  return (
    <main className="main">
      <div className="card-white card-shadow relative">
        {/* <Button variant="close page-close"></Button> */}
        {isFormActive ? (
          <div className="display-view">
            <div className="text-center">
              {formDetails?.banner ? (
                <div className="for-banner mb-4">
                  {formDetails?.formSetting?.logoURL && (
                    <img src={formDetails?.formSetting?.logoURL} alt="banner" />
                  )}
                </div>
              ) : (
                <div className="for-logo mb-4">
                  {formDetails?.formSetting?.logoURL && (
                    <img src={formDetails?.formSetting?.logoURL} alt="logo" />
                  )}
                </div>
              )}
              <h3 className="text-xl font-semibold text-slate-600">
                {formDetails?.formName || ""}
              </h3>
            </div>
            {/* <hr /> */}
            {
              <div
                className="py-3"
                style={{
                  backgroundImage:
                    `url(${formDetails?.formSetting?.backgroundImageURL})` ||
                    undefined,
                }}
              >
                <Form>
                  <div className="form-box mb-4 pb-4 rounded-3 border bg-grey-50 pl-4 pr-4">
                    <Row>
                      {viewForm?.pages?.length > 0 &&
                        viewForm?.pages
                          ?.filter((i) => i.sequenceNo == counter)
                          ?.map((item, itemIndex) => {
                            return (
                              <>
                                {item?.sections?.map((sect, sectionIndex) => {
                                  return (
                                    <>
                                      {sect?.type == "sectn" &&
                                        (sect.addrule
                                          ? sect.show &&
                                          retFind(viewForm, sect, true)
                                          : true) && (
                                          <>
                                            <div className="col-12 section-header">
                                              <div className="pt-3 border-top">
                                                <div className="text-md font-medium text-slate-700 px-4">
                                                  <span className="">
                                                    {sect?.label}
                                                  </span>
                                                </div>
                                                <div
                                                  className="d-block mb-3 px-4"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      sect.sectionDescription &&
                                                        sect.sectionDescription
                                                          .length > 0
                                                        ? convertTextToLink(
                                                          sect.sectionDescription
                                                        )
                                                        : "",
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      {(sect.addrule
                                        ? sect.show &&
                                        retFind(viewForm, sect, true)
                                        : true) &&
                                        sect?.questions?.map(
                                          (item, index, arr) => {
                                            return (
                                              <>
                                                {item.typename == "short" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Shorttext
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "long" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Longtext
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "paragraph" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Paragraph
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "number" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Numbers
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "web" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Website
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "call" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <PhoneNo
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "loc" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Address
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "description" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Description
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "signature" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Signature
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={viewForm?.status}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "drop_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <DropDown
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "toggle_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <YesNoChoose
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "check_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Checkbox
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "multiChecks" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <MultiCheckbox
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "mutiple_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Radiobutton
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "fileUp" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <FileUpload
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={appID}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "fileDown" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <FileDownload
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "dates" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Dates
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "times" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Times
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "emails" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Emails
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "confirms" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Confirmations
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "auto_complete" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <AutoComplete
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={queryParams}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                      viewFormAction={
                                                        viewFormAction
                                                      }
                                                    />
                                                  )}
                                                {item.typename == "video" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <VideoComp
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={queryParams}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                      viewFormAction={
                                                        viewFormAction
                                                      }
                                                    />
                                                  )}
                                                {item.typename == "record" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <VideoRecord
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={queryParams}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                      viewFormAction={
                                                        viewFormAction
                                                      }
                                                    />
                                                  )}
                                                {item.typename == "image" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Images
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={queryParams}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                      viewFormAction={
                                                        viewFormAction
                                                      }
                                                    />
                                                  )}
                                                {item.typename == "rate" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Rating
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={queryParams}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                      viewFormAction={
                                                        viewFormAction
                                                      }
                                                    />
                                                  )}
                                                {item.typename == "multiinp" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <MultiInput
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={queryParams}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={setfirst}
                                                      first={first}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                      viewFormAction={
                                                        viewFormAction
                                                      }
                                                    />
                                                  )}
                                              </>
                                            );
                                          }
                                        )}
                                    </>
                                  );
                                })}
                                {item?.type == "pgbreak" && (
                                  <PageBreak
                                    status={"preview"}
                                    setsettings={() => { }}
                                    eleavailable={viewForm.pages}
                                    viewForm={item?.pageId}
                                    setviewSetting={() => { }}
                                    settings={""}
                                    setpagebk={() => { }}
                                    allElements={[]}
                                    formId={formId}
                                    setcounter={setcounter}
                                    counter={counter}
                                    setviewForm={setviewForm}
                                    dynaDDselarr={item?.sequenceNo}
                                  />
                                )}
                              </>
                            );
                          })}
                    </Row>
                  </div>
                  <div className="text-center">
                    {counter == viewForm?.pages?.length - 1 && (
                      <Button
                        disabled={
                          waits ||
                          subFlag ||
                          viewForm?.status === "Submitted" ||
                          isEndDateExpired
                        }
                        variant="primary"
                        type="submit"
                        onClick={handleApplicationSave}
                      >
                        Submit Form
                      </Button>
                    )}
                  </div>
                </Form>
                {viewForm?.thankyoumessage && (
                  <ThankYouModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    msgObj={viewForm?.formSetting}
                  />
                )}
              </div>
            }
          </div>
        ) : (
          <div className="display-view">
            <div className="text-center">
              <h3>{notActiveMessage}</h3>
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default Application;
